<template>
  <div>
    <Push />
  </div>
</template>
<script>
import Push from "./components/Push";
export default {
  components: {
    Push,
  },
};
</script>
